import { useEffect, useState } from 'react';
import type { IdentityTrpcClient } from './trpc';

/** Reads the intentionally minimal public capability contract. */
export function useGoogleOAuthAvailable(client: IdentityTrpcClient): boolean {
  const [available, setAvailable] = useState(false);

  useEffect(() => {
    let active = true;
    const capability = client.googleFederation?.capability;
    if (!capability) return () => { active = false; };
    capability.query()
      .then((result) => { if (active) setAvailable(result.enabled); })
      .catch(() => { if (active) setAvailable(false); });
    return () => { active = false; };
  }, [client]);

  return available;
}
